export const actionTypes = {
  TOAST_MESSAGE: 'TOAST_MESSAGE'
};

export function throwToast(payload) {
  return {
    type: actionTypes.TOAST_MESSAGE,
    payload
  };
}
